{
    This file is part of the Pas2JS run time library.
    Copyright (c) 2022 by Michael Van Canneyt
    
    Browser WebAssembly API definitions

    See the file COPYING.FPC, included in this distribution,
    for details about the copyright.

    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

 **********************************************************************}

{$IFNDEF FPC_DOTTEDUNITS}
unit webassembly;
{$ENDIF}

{$mode objfpc}
{$modeswitch externalclass}

interface

uses
{$IFDEF FPC_DOTTEDUNITS}
  JSApi.JS;
{$ELSE}
  js;
{$ENDIF}  

Type
  { TJSWebAssemblyMemory }

  TJSWebAssemblyMemoryDescriptor = record
    initial,
    maximum : integer;
    shared : Boolean;
  end;

  TJSWebAssemblyMemory = class external name 'WebAssembly.Memory' (TJSObject)
  private
    FBuffer: TJSArrayBuffer; external name 'buffer';
    FSharedBuffer: TJSSharedArrayBuffer; external name 'buffer';
  Public
    constructor new (memorydescriptor : TJSWebAssemblyMemoryDescriptor);
    constructor new (memorydescriptor : TJSObject);
    Function grow(number : NativeInt) : NativeInt; external name 'grow';
    Property buffer : TJSArrayBuffer Read FBuffer;
    Property Sharedbuffer : TJSSharedArrayBuffer Read FSharedBuffer;
  end;

  { TJSWebAssemblyMemoryHelper }

  TJSWebAssemblyMemoryHelper = class helper for TJSWebAssemblyMemory
    function IsSharedBuffer : Boolean;
  end;

  { TJSModulesArray }

  TJSModulesExports = Class external name 'Object' (TJSObject)
  private
    FMemory : TJSWebAssemblyMemory; external name 'memory';
    function GetFun(aName : String): TJSFunction; external name '[]';
  public
    Property Memory : TJSWebAssemblyMemory Read FMemory Write fMemory;
    Property functions [aName : String] : TJSFunction read GetFun; default;
  end;

  TJSModulesImports =  TJSModulesExports;

  TJSWebAssemblyModule = class external name 'WebAssembly.Module' (TJSObject)
    constructor new(buffer : TJSArrayBuffer);
    Class Function customSections(module: TJSWebAssemblyModule; const SectionName : string) : TJSArrayBuffer;
    Class Function exports_(module: TJSWebAssemblyModule) : TJSModulesExports; external name 'exports';
    Class Function imports(module: TJSWebAssemblyModule) : TJSModulesImports; external name 'imports';
  end;

  { TJSWebAssemblyInstance }

  TJSWebAssemblyInstance = class external name 'WebAssembly.Instance' (TJSObject)
  private
    Fexports: TJSModulesExports; external name 'exports';
  public
    constructor new(module : TJSWebAssemblyModule; ImportObject : TJSOBject);
    constructor new(module : TJSWebAssemblyModule);
    Property exports_ : TJSModulesExports Read Fexports;
  end;

  { TJSInstantiated }
  // Result returned when calling instantiate with buffer

  { TJSInstantiateResult }

  TJSInstantiateResult = Class external name 'anon' (TJSObject)
  private
    FInstance: TJSWebAssemblyInstance; external name 'instance';
    FModule: TJSWebAssemblyModule;  external name 'module';
  public
    Property Module : TJSWebAssemblyModule Read FModule;
    Property Instance : TJSWebAssemblyInstance Read Finstance;
  end;

  TJSWebAssembly = class external name 'WebAssembly' (TJSObject)
    Class Function instantiate(Buffer : TJSArrayBuffer; ImportObject :  TJSObject) : TJSPromise; overload;
    Class Function instantiate(Buffer : TJSArrayBuffer) : TJSPromise; overload;
    Class Function instantiate(Buffer : TJSWebAssemblyModule; ImportObject :  TJSObject) : TJSPromise; overload;
    Class Function instantiate(Buffer : TJSWebAssemblyModule) : TJSPromise; overload;
    Class Function compile(Buffer : TJSArrayBuffer): TJSPromise;
    Class Function compileStreaming(source : TJSObject): TJSPromise;
    Class Function instantiateStreaming(source : TJSObject; ImportObject :  TJSObject) : TJSPromise; overload;
    Class Function instantiateStreaming(source : TJSObject) : TJSPromise; overload;
    Class Function validate(Buffer : TJSArrayBuffer): Boolean;
    Class function promising(aFunction : TJSFunction) : TJSFunction;
  end;

  TJSSuspending = class external name 'WebAssembly.Suspending' (TJSObject)
    constructor new(aFunc : TJSFunction);
  end;

  { TJSWebAssemblyTable }

  TJSWebAssemblyTableDescriptor = record
    element : string;
    initial,
    maximum : integer;
  end;

  TJSWebAssemblyTable = class external name 'WebAssembly.Table' (TJSObject)
  private
    FLength: NativeInt;
  Public
    constructor new (tabledescriptor : TJSWebAssemblyTableDescriptor);
    constructor new (tabledescriptor : TJSObject);
    Property length: NativeInt Read FLength;
  end;

  TJSWebAssemblyException = class external name 'WebAssembly.Exception' (TJSObject)
    stack : string;
  end;


implementation

{ TJSWebAssemblyMemoryHelper }

function TJSWebAssemblyMemoryHelper.IsSharedBuffer: Boolean;
begin
  Result:=False;
  asm
  return ((!(buffer === null)) && (typeof this.FBuffer === 'object'))
          && (this.FBuffer instanceof SharedArrayBuffer);
  end;
end;

end.

